export const ClientNotificationDeliveryStatus = {
	pending: 1,
	sending: 2,
	delivered: 3,
	failed: 4,
	rejected: 5,
	dead: 6,
};
